import { Injectable } from "@angular/core";
import { HoldingTankService } from "@app/services/myoffice/member/holding-tank.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as memberNullPidAction from "@app/actions/myoffice/member/holding-tank.action"
import { catchError, map, mergeMap, of } from "rxjs";


@Injectable()
export class HoldingTankEffect{
    constructor(
        private actions$: Actions,
        private memberNullPid: HoldingTankService
    ){}

    findListMemberNullPid = createEffect(() => this.actions$.pipe(
        ofType(memberNullPidAction.findListMemberNullPid),
        mergeMap(({ params }) => this.memberNullPid.listMemberNullPid(params)
          .pipe(
            map(
              res => (memberNullPidAction.findListMemberNullPidSuccess({ member: res })
              )),
            catchError(
              msg => of(memberNullPidAction.findListMemberNullPidFailure({ msg: msg })
              ))
          ))
      )
    );

    countListMemberNullPid = createEffect(() => this.actions$.pipe(
        ofType(memberNullPidAction.countListMemberNullPid),
        mergeMap(({ params }) => this.memberNullPid.countMemberNullPid(params)
          .pipe(
            map(
              res => (memberNullPidAction.countListMemberNullPidSuccess({ total: res })
              )),
            catchError(
              msg => of(memberNullPidAction.countListMemberNullPidFailure({ msg: msg })
              ))
          ))
      )
    );

    savePid = createEffect(() => this.actions$.pipe(
        ofType(memberNullPidAction.savePid),
        mergeMap(({ params }) => this.memberNullPid.savePid(params)
          .pipe(
            map(
              res => (memberNullPidAction.savePidSuccess({ result: res })
              )),
            catchError(
              msg => of(memberNullPidAction.savePidFailure({ msg: msg })
              ))
          ))
      )
    );
}